import { gql } from "@apollo/client";export default gql`mutation DeleteGroupCollection($ids: [Int!]) {
    delete_group_collection(where: { id: { _in: $ids } }) {
        affected_rows
    }
}
`;
